import Dashboard from './components';

export default {
  protected: true,
  path: '/dashboard/',
  key: '/dashboard/',
  exact: true,
  component: Dashboard,
};
